/* eslint-disable */
import Backbone from 'backbone';
import _ from 'underscore';
import ko from 'knockout';
import bootstrap from 'bootstrap';
import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';
import tmpl from '@bingads-webui-campaign-legacy/crud-adgroup/template/create.pug';
import CreateViewModel from '@bingads-webui-campaign-legacy/crud-adgroup/viewmodel/create';
import withUiBlock from '@bingads-webui-component-legacy/uiblocker/index';
import * as i18nErrors from '@bingads-webui-component-legacy/api-errors-campaign/index';
import * as scrollUtil from '@bingads-webui-component-legacy/extension/scrollTo';
import config from '@bingads-webui-component-legacy/config/index';
import * as errorExtractor from '@bingads-webui-campaign-legacy/crud-adgroup/share/errorExtractor';
import instrumentation from '@bingads-webui-static-legacy/instrumentation/index';
import constants from '@bingads-webui-static-legacy/instrumentation/constants';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');
var View = Backbone.View.extend({
  events: {
    'click .btn-create-adgroup': 'createAndRefocus'
  },
  initialize: function (options) {
    var self = this;
    self.options = _.defaults({}, options, {
      maxAdGroups: 100,
      isOptional: false,
      checkAdGroupNameDuplicates: null
    });
    self.adapter = {
      adapter: self.options.adapter || 'bulk'
    };
    self.ko_model = new CreateViewModel({
      maxAdGroups: this.options.maxAdGroups,
      campaignType: this.options.campaignType,
      isMixedModeCampaignCreation: options.isMixedModeCampaignCreation,
      isForVNext: options.isForVNext
    });
    self.existError = false;
    this.updateViews = [];
  },
  willShow: function (shouldNotCreateDefaultEditor, shouldNotRenderWhenThereIsNoAdGroup) {
    window.scrollTo(0, 0);
    var self = this;
    if (self.options.context instanceof Backbone.Model) {
      self.campaign = self.options.context.get('Campaign');
      if (self.ko_model.adGroups().length === 0 && !shouldNotRenderWhenThereIsNoAdGroup) {
        self.render(shouldNotCreateDefaultEditor);
      } else {
        _.each(self.ko_model.adGroups(), function (adGroup) {
          adGroup.updateCampaign();
        });
        _.invoke(self.ko_model.adGroups(), 'updateOnVisible');
      }
    }
    self.ko_model.hasChanges(false);
  },
  hasChanges: function () {
    return this.ko_model.hasChanges();
  },
  shouldNext: function () {
    return this.save(true);
  },
  shouldBack: function () {
    if (this.validate()) {
      this.save(false);
    }
    return true;
  },
  shouldCancel: function () {
    return this.save(true);
  },
  getUpdates: function (shouldValidate) {
    var self = this;
    var updates = {
      Id: self.campaign.Id,
      AdGroups: []
    };
    if (shouldValidate) {
      if (!self.validate()) {
        return false;
      }
      self.existError = false;
    }
    _.each(self.ko_model.adGroups(), function (adGroup, index) {
      var changes = adGroup.getChanges();
      if (!_.isNull(changes)) {
        changes.AdScheduleUseSearcherTimeZone = false;
        updates.AdGroups.push(changes);
      }
    });
    return updates;
  },
  errorElements: function () {
    return this.$('.adgroups-keywords__container .error, .adgroups-keywords__container .alert-danger').filter(':visible');
  },
  showErrorElements: function () {
    this.selectedAdGroup = null;
    _.each(this.ko_model.adGroups(), function (adGroup) {
      if (!adGroup.ko_model.isOpen()) {
        adGroup.collapse('show');
      }
    });
    setTimeout((function () {
      scrollUtil.scrollAndCenter(this.errorElements());
    }).bind(this), 500);
  },
  save: function (shouldValidate) {
    var self = this;
    var updates = self.getUpdates(shouldValidate);
    var saveAdGroupKeywordMarker = null;
    if (updates === false) {
      self.showErrorElements();
      return false;
    }
    if (_.size(updates.AdGroups) === 0) {
      if (self.existError) {
        return false;
      }
      self.updateContext();
      return true;
    }
    if (this.options && this.options.perfMarker) {
      saveAdGroupKeywordMarker = this.options.perfMarker.createChild('Save_AdGroup_Keyword');
      saveAdGroupKeywordMarker.willInit();
    }
    var updatedAdgroupsCount = _.size(_.filter(updates.AdGroups, function (ag) {
      return _.has(ag, 'Id');
    }));
    var createdAdgroupsCount = _.size(updates.AdGroups) - updatedAdgroupsCount;
    var adgroupType = _.result(_.first(updates.AdGroups), 'AdGroupType');
    self.existError = false;
    return jsdata.Campaign.update(self.campaign.Id, updates, self.adapter).then(function (data) {
      if (updatedAdgroupsCount > 0) {
        instrumentation.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, `updateAdgroup | type: ${adgroupType}`, updatedAdgroupsCount);
      }
      if (createdAdgroupsCount > 0) {
        instrumentation.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, `createAdgroup | type: ${adgroupType}`, createdAdgroupsCount);
      }
      _.each(data.AdGroups, function (adGroup) {
        var toUpdate = _.find(self.ko_model.adGroups(), function (adGroupView) {
          return adGroupView.ko_model.options.index === parseInt(adGroup['Client Id']);
        }, self);
        if (toUpdate) {
          toUpdate.updateViewModels(adGroup);
        }
        if (self.options.instrumentation) {
          self.options.instrumentation.instrument('save', adGroup);
        }
      });
      self.updateContext(createdAdgroupsCount, updatedAdgroupsCount, adgroupType);
      if (saveAdGroupKeywordMarker) {
        saveAdGroupKeywordMarker.done();
      }
      return true;
    }).catch(function (errors) {
      self.existError = true;
      if (self.options.activityLogger && errors && errors.errors) {
        _.chain(errors.errors).map(function (error) {
          return error.Error;
        }).uniq().each(function (error) {
          self.options.activityLogger.signal(error, 'adgroup creation api error');
        });
      }
      if (!_.isObject(errors) || !_.isObject(errors.entity)) {
        self.showErrorElements();
        if (errors && errors.errors) {
          self.ko_model.errors.add(i18nErrors.getODataErrors(errors.errors));
        }
        return false;
      }
      var hasErrors = _.map(errors.entity.AdGroups, function (adGroup) {
        var errorList = _.where(errors.errors, {
          'Client Id': adGroup['Client Id']
        });
        var subEntity = self.options.isAutoTargetCampaign ? 'DsaTargets' : 'Keywords';
        var canEdit = self.options.isAutoTargetCampaign;
        errorExtractor.extract(adGroup, errors, errorList, subEntity, canEdit);
        var toUpdate = _.find(self.ko_model.adGroups(), function (adGroupView) {
          return adGroupView.ko_model.options.index === parseInt(adGroup['Client Id']);
        });
        if (toUpdate) {
          if (_.isEmpty(errorList)) {
            toUpdate.updateViewModels(adGroup);
          } else {
            toUpdate.updateViewModelsOnError({
              entity: adGroup,
              errors: errorList
            }, subEntity);
          }
        }
        return !_.isEmpty(errorList);
      });
      if (_.some(hasErrors)) {
        self.showErrorElements();
        return false;
      } else {
        self.updateContext(createdAdgroupsCount, updatedAdgroupsCount, adgroupType);
        self.existError = false;
        return true;
      }
    }).finally(withUiBlock());
  },
  validate: function () {
    var isValid = _.chain(this.ko_model.adGroups()).map(function (adGroup) {
      return adGroup.validate();
    }).every().value();
    this.ko_model.isValid(isValid);
    return isValid;
  },
  updateContext: function (createdAdgroupsCount, updatedAdgroupsCount, adgroupType) {
    if (this.options.activityLogger && createdAdgroupsCount > 0) {
      this.options.activityLogger.signal(createdAdgroupsCount, `create adgroup | type: ${adgroupType}`);
    }
    if (this.options.activityLogger && updatedAdgroupsCount > 0) {
      this.options.activityLogger.signal(updatedAdgroupsCount, `update adgroup | type: ${adgroupType}`);
    }
    var contextAdGroups = [];
    _.each(this.ko_model.adGroups(), function (adGroup, index) {
      contextAdGroups.push(adGroup.getContextObject());
    });
    this.options.context.set({
      'AdGroups': contextAdGroups
    });
  },
  render: function () {
    if (!_.isUndefined(this.campaign)) {
      this.$el.html(tmpl({
        isAutoTargetCampaign: this.options.isAutoTargetCampaign,
        i18n: i18n,
        maxAdGroupsError: i18n.get('AdGroup_Message_MaxAdGroups').replace('{0}', this.ko_model.maxAdGroups)
      }));
      ko.applyBindings(this.ko_model, this.el);
      this.$('.ad-group-list-container')[0].addEventListener('change', (function () {
        this.ko_model.hasChanges(true);
      }).bind(this), false);
    }
    return this;
  },
  create: function () {
    var self = this;
    if (self.ko_model.hasMaxAdGroups()) {
      return;
    }
    self.ko_model.numCreated++;
    var updateView = new self.options.UpdateView(_.extend({}, self.options, {
      index: self.ko_model.numCreated,
      context: self.options.context,
      adapter: self.options.adapter,
      showErrorsInline: true,
      instrumentation: self.options.instrumentation,
      defaultBid: self.options.defaultBid,
      activityLogger: self.options.activityLogger,
      isForVNext: self.options.isForVNext,
      hideHeader: self.options.hideHeader
    })).render();
    this.updateViews.push(updateView);
    self.ko_model.addAdGroup(updateView);
    self.trigger('createAdGroupEditorView', updateView);
    if (_.size(self.ko_model.adGroups()) <= 1) {
      if (!self.options.isOptional) {
        updateView.ko_model.isOnlyAdGroup(true);
      }
    } else if (_.size(self.ko_model.adGroups()) >= 2) {
      self.ko_model.adGroups()[0].ko_model.isOnlyAdGroup(false);
    }
    if (_.isObject(self.selectedAdGroup) && self.selectedAdGroup.ko_model.isOpen()) {
      self.selectedAdGroup.validate();
    }
    self.changeSelectedAdGroup(updateView);
    var isDuplicated = self.ko_model.isDuplicateName(updateView.ko_model.Name(), updateView.options.index);
    updateView.ko_model.isNameDuplicate(isDuplicated);
    var logNameChange = _.once(function () {
      if (self.options.activityLogger) {
        self.options.activityLogger.signal('adgroup name change');
      }
    });
    updateView.on({
      'show': function (newSelected, e) {
        self.changeSelectedAdGroup(newSelected);
      },
      'delete': function (deletedAdGroup) {
        self.updateViews = self.updateViews.filter(function (view) {
          return view !== updateView;
        });
        if (self.options.activityLogger) {
          self.options.activityLogger.signal('remove adgroup clicked');
        }
        self.ko_model.hasChanges(true);
        self.ko_model.removeAdGroup(deletedAdGroup);
        if (self.lastDeleted && self.lastDeleted.$('.deletedConfirmation')) {
          self.lastDeleted.$el.hide();
        }
        self.lastDeleted = deletedAdGroup;
        if (_.isEqual(self.selectedAdGroup, deletedAdGroup)) {
          self.selectedAdGroup = null;
        }
        if (!self.options.checkAdGroupNameDuplicates) {
          self.ko_model.checkDuplicates();
        } else {
          self.options.checkAdGroupNameDuplicates();
        }
        if (_.size(self.ko_model.adGroups()) === 1) {
          var onlyAdGroup = self.ko_model.adGroups()[0];
          if (!self.options.isOptional) {
            onlyAdGroup.ko_model.isOnlyAdGroup(true);
            if (!onlyAdGroup.ko_model.isOpen()) {
              onlyAdGroup.collapse('show');
            }
          }
        }
      },
      'nameChanged': function (adGroup) {
        logNameChange();
        if (!self.options.checkAdGroupNameDuplicates) {
          var isDuplicated = self.ko_model.isDuplicateName(adGroup.ko_model.Name(), adGroup.options.index);
          adGroup.ko_model.isNameDuplicate(isDuplicated);
          self.ko_model.checkDuplicates();
        } else {
          self.options.checkAdGroupNameDuplicates();
        }
      },
      'selectThisAdGroup': function (adGroup) {
        if (_.isNull(self.selectedAdGroup) || self.selectedAdGroup.options.index !== adGroup.options.index) {
          self.changeSelectedAdGroup(adGroup);
        }
      }
    });
    self.$('.ad-group-list').append(updateView.el);
    self.ko_model.hasChanges(true);
  },
  createAndRefocus: function () {
    if (this.options.activityLogger) {
      this.options.activityLogger.signal('add new adgroup clicked');
    }
    this.create();
    _.last(this.$('.adgroup-name')).focus();
  },
  changeSelectedAdGroup: function (newSelected) {
    if (_.isObject(this.selectedAdGroup) && this.selectedAdGroup.ko_model.isOpen() && !this.selectedAdGroup.ko_model.isOnlyAdGroup()) {
      this.selectedAdGroup.collapse('hide');
    }
    this.selectedAdGroup = newSelected;
  }
});
export default View;

